import React from 'react';
export function Footer() {
  return <footer className="bg-bg border-t border-border py-7 px-5 text-center text-[12px] text-muted leading-[1.8] pb-24" data-id="element-62">
      <p data-id="element-63">© Gelatinas de Lujo — Todos los Derechos Reservados</p>
      <p className="mt-2" data-id="element-64">
        Soporte · Política de Privacidad · Términos y Condiciones
      </p>
      <p className="mt-3 max-w-[560px] mx-auto opacity-60" data-id="element-65">
        Los resultados mencionados son individuales y reales. Los resultados de
        cada persona dependen de su dedicación y aplicación del método. No
        garantizamos ingresos específicos.
      </p>
    </footer>;
}